import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { UnsafeAction } from '../../../actions/UnsafeAction';
import { TicketCreationDTO } from "../../../services/webservice"
import * as model from "../../../models";
import { TicketQuota } from "../../../models";

// tslint:disable:member-ordering
@Injectable()
export class BoxOfficeActions {
	static GET_MY_SHOPPINGCART_BO = "[BoxOffice] GET_MY_SHOPPINGCART";
	getMyShoppingCartBoxOffice(): Action {
		return {
			type: BoxOfficeActions.GET_MY_SHOPPINGCART_BO
		}
	}

	static GET_MY_SHOPPINGCART_SUCCESS_BO = "[BoxOffice] GET_MY_SHOPPINGCART_SUCCESS";
	getMyShoppingCartSuccess(myShoppingCart: model.ShoppingCart): UnsafeAction {
		return {
			type: BoxOfficeActions.GET_MY_SHOPPINGCART_SUCCESS_BO,
			payload: myShoppingCart
		}
	}

	static SET_HAS_ERRORS_BO = "[BoxOffice] set shoppingcart has errors";
	public setHasErrors(): Action {
		return {
			type: BoxOfficeActions.SET_HAS_ERRORS_BO
		}
	}

	static UNSET_HAS_ERRORS_BO = "[BoxOffice] shoppingcart unset has errors";
	public unsetHasErrors(): Action {
		return {
			type: BoxOfficeActions.UNSET_HAS_ERRORS_BO
		}
	}

	static ADD_TICKETS_BO = "[BoxOffice] add Tickets";
	public addTicketsBoxOffice(url: string, ticketCreationDTOs: TicketCreationDTO[], selectedTicketQuotaId: string) {
		return {
			type: BoxOfficeActions.ADD_TICKETS_BO,
			payload: {url: url, ticketCreationDTOs: ticketCreationDTOs, selectedTicketQuotaId: selectedTicketQuotaId}
		}
	}

	static ADD_VISUAL_BULK_TICKETS_BO = "[BoxOffice] add visual bulk Tickets";
	public addVisualBulkTicketsBoxOffice(url: string, ticketCreationDTOs: TicketCreationDTO[], selectedTicketQuotaId: string) {
		return {
			type: BoxOfficeActions.ADD_VISUAL_BULK_TICKETS_BO,
			payload: {url: url, ticketCreationDTOs: ticketCreationDTOs,  selectedTicketQuotaId: selectedTicketQuotaId}
		}
	}

	static REMOVE_TICKETS_BO = "[BoxOffice] remove Tickets";
	public removeTicketsBoxOffice(url: string, ticketItemUuids: string[]) {
		return {
			type: BoxOfficeActions.REMOVE_TICKETS_BO,
			payload: {url: url, ticketItemUuids: ticketItemUuids}
		}
	}

	static DELETE_SHOPPINGCART_BO= "[BoxOffice] delete ShoppingCart";
	public deleteShoppingCartBoxOffice(url: string): UnsafeAction {
		return {
			type: BoxOfficeActions.DELETE_SHOPPINGCART_BO,
			payload: url
		}
	}

	static PLACE_ORDER_BO = "[BoxOffice] place order"
	public placeOrderBoxOffice(order: model.OrderDTO): UnsafeAction {
		return {
			type: BoxOfficeActions.PLACE_ORDER_BO,
			payload: order
		}
	}

	static ORDER_PLACED_BO = "[BoxOffice] order placed"
	public orderPlacedBoxOffice(order: model.Order): UnsafeAction {
		return {
			type: BoxOfficeActions.ORDER_PLACED_BO,
			payload: order
		}
	}

	static COMPLETE_PAYMENT_BO = "[BoxOffice] complete payment"
	public completePaymentBoxOffice(orderUUID: string): UnsafeAction {
		return {
			type: BoxOfficeActions.COMPLETE_PAYMENT_BO,
			payload: orderUUID
		}
	}

	static SET_SELECTED_TICKETQUOTA_BO = "[BoxOffice] set selected ticketquota"
	public setSelectedTicketQuotaBoxOffice(ticketQuota: TicketQuota): UnsafeAction {
		return {
			type: BoxOfficeActions.SET_SELECTED_TICKETQUOTA_BO,
			payload: ticketQuota
		}
	}

	static REFRESH_SELECTED_TICKETQUOTA_BO = "[BoxOffice] refresh selected ticketquota"
	public refreshSelectedTicketQuotaBoxOffice(ticketQuota: TicketQuota): UnsafeAction {
		return {
			type: BoxOfficeActions.REFRESH_SELECTED_TICKETQUOTA_BO,
			payload: ticketQuota
		}
	}

	static CLEAR_EVENTSERVER_STATE = "[BoxOffice] clear whole event server state"
	public clearEventServerState(): Action {
		return {
			type: BoxOfficeActions.CLEAR_EVENTSERVER_STATE
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/box-office/ngrx/box-office.actions.ts